import React, { useMemo } from "react";
import PresupuestoTemplate from "../components/presupuesto/PresupuestoTemplate";

/**
 * Pagina standalone para renderizar el PDF de cotizacion de un prospecto.
 *
 * La genera la Cloud Function `onLeadQuoting` (Puppeteer): navega a
 * `/cotizacion-pdf#<base64(config)>`, espera el marcador `#pdf-ready` e imprime.
 *
 * El `config` (PresupuestoConfig) viaja en el hash en base64 para no requerir
 * auth ni lectura de Firestore desde la pagina (Puppeteer no esta logueado).
 */
export default function CotizacionPrint() {
  const config = useMemo(() => {
    try {
      const raw = decodeURIComponent((window.location.hash || "").replace(/^#/, ""));
      if (!raw) return null;
      // base64 (utf-8) -> json
      const json = decodeURIComponent(escape(window.atob(raw)));
      return JSON.parse(json);
    } catch (e) {
      console.error("CotizacionPrint: hash invalido", e);
      return null;
    }
  }, []);

  if (!config) {
    return <div style={{ padding: 40, fontFamily: "sans-serif" }}>Cotización no disponible.</div>;
  }

  return (
    <div style={{ background: "#fff" }}>
      <PresupuestoTemplate config={config} />
      {/* Marcador que Puppeteer espera antes de imprimir el PDF. */}
      <div id="pdf-ready" style={{ position: "fixed", width: 0, height: 0, opacity: 0 }} />
    </div>
  );
}
